import Vue from 'vue'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import './utils/Filters'
import './assets/animate.css'
import './main.scss'

Vue.config.productionTip = false

Vue.filter('truncate', function (text, length, suffix) {
  if (text.length <= length) {
    return text;
  }
  return text.substring(0, length) + (suffix || '...');
});

import money from 'v-money'
Vue.use(money, {precision: 0})

//Vue Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GMAPS_API_KEY,
    libraries: 'places',
  },
})


import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';
Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: '...', // Can also be an object. E.g, for Google Maps Premium API, pass `{ client: <YOUR-CLIENT-ID> }`
  // version: '...', // Optional
  // language: '...', // Optional
});

import VueMoment from 'vue-moment'
const moment = require('moment')
require('moment/locale/es')
Vue.use(VueMoment, {
  moment
})
/*
import moment from 'moment-timezone'
moment.tz.setDefault('America/Santiago')*/


import VueHtmlToPaper from "vue-html-to-paper";

// ...
const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=no", "scrollbars=no", "toolbar=no", "height=500", "width=600"],
  styles: [
    "/css/print.css"
  ]
};

Vue.use(VueHtmlToPaper, options);

//Particles
import Particles from "particles.vue";
Vue.use(Particles);

//Vue Tour
import VueTour from 'vue-tour'
require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)

import VueFB from './plugins/vue-fb'

Vue.use(VueFB, {
  appId: process.env.VUE_APP_FACEBOOK_CLIENT_ID,
  autoLogAppEvents: true,
  xfbml: true,
  version: 'v2.9'
})

//Vue Wysiwyg
import "vue-wysiwyg/dist/vueWysiwyg.css";
import wysiwyg from "vue-wysiwyg";
Vue.use(wysiwyg, {
  hideModules: {
    "justifyLeft": true,
    "justifyCenter": true,
    "justifyRight": true,
    "headings": true,
    "code": true,
    "image": true,
    "table": true,
    "link": true,

  }
}); // config is optional. more below

import VueSocialSharing from 'vue-social-sharing'
Vue.use(VueSocialSharing);

import GlobalMixin from "./mixins/GlobalMixin";
Vue.use(require('vue-prevent-parent-scroll'))
Vue.mixin(GlobalMixin)

import VueDraggableResizable from 'vue-draggable-resizable'
Vue.component('vue-draggable-resizable', VueDraggableResizable)

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
